module.exports = __webpack_public_path__ + "static/media/promotion-popup.8619615d.jpg";